import { merge, get, set, clone, concat } from 'lodash';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
let initState = {
	albumList: [],
	totalCount: 8,
	sportList: [1, 2],
	pageIndex: 1,
	pageSize: 7,
	isUpdate: 0
};
export function CopyrightHomeReducers(state = initState, action) {
	switch (action.type) {
		case ACITONCOPYRIGHT.SET_COPYRIGHT_TOPICLIST: {
			// console.log('action...', action);
			let payload = get(action, 'payload', []);
			console.log('payload...', payload);
			state.albumList = payload.records;
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_COPYRIGHT_SPORTLIST: {
			// console.log('action...', action);
			let payload = get(action, 'payload', {});
			let { totalCount, pageIndex, records = [] } = payload || {};
			if (records.length > 0) {
				if (pageIndex === 1) {
					state.sportList = records;
				} else {
					state.sportList = concat(state.sportList, records);
				}
				return merge({}, state, { totalCount, pageIndex });
			}
			return state;
		}
		case ACITONCOPYRIGHT.SET_PLACARDITEM_LIST: {
			let { payload } = action;
			console.log('payload placardItem config list ...', payload);

			let { totalCount, pageIndex, records = [] } = payload || {};
			if (records && records.length > 0) {
				if (pageIndex === 1) {
					state.placardItemList = records;
				} else {
					state.placardItemList = concat(state.placardItemList, records);
				}
				state.isUpdate = 1;
				return merge({}, state, { totalCount, pageIndex });
			}
			// state.placardItemList = payload||[];
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_GALLERYIMG_HOME: {
			let payload = get(action, 'payload', []);
			let { index, operation = 0 } = payload;
			console.log('index...', index);
			// alert(index)
			let placardItem = {};
			if (state.placardItemList[index].topicContentResponses && state.placardItemList[index].topicContentResponses.length > 0) {
				placardItem = state.placardItemList[index].topicContentResponses.find(t => t.isCover) || state.placardItemList[index].topicContentResponses[0];
			}
			placardItem.likeStatus = operation;
			if (operation) {
				//+1
				++placardItem.endorseCount;
			} else {
				//-1
				--placardItem.endorseCount;
			}
			state.placardItemList = clone(state.placardItemList);
			state.isUpdate = 1;
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_COPYRIGHT_NEWSPRAISE_HOME: {
			let payload = get(action, 'payload', []);
			let { index } = payload;
			// alert(index)
			let placardItem = {};
			if (state.placardItemList[index].topicContentResponses && state.placardItemList[index].topicContentResponses.length > 0) {
				placardItem = state.placardItemList[index].topicContentResponses[0];
			}
			placardItem.likeStatus = 1;
			++placardItem.endorseCount;
			state.placardItemList = clone(state.placardItemList);
			state.isUpdate = 1;
			return merge({}, state, {});
		}
		case ACITONCOPYRIGHT.SET_COPYRIGHT_CANCELNEWSPRAISE_HOME: {
			let payload = get(action, 'payload', []);
			let { index } = payload;
			// alert(index)
			let placardItem = {};
			if (state.placardItemList[index].topicContentResponses && state.placardItemList[index].topicContentResponses.length > 0) {
				placardItem = state.placardItemList[index].topicContentResponses[0];
			}
			placardItem.likeStatus = 0;
			--placardItem.endorseCount;
			state.placardItemList = clone(state.placardItemList);
			state.isUpdate = 1;
			return merge({}, state, {});
		}
		default:
			return state;
	}
}
